import * as React from "react";
import { useContext } from "react";
import { SearchContext } from "../SearchContext";
import { SchoolSearch } from "./SchoolSearch";
import { InternationalSchoolSearch } from "./InternationalSchoolSearch";
import { IbybSearch } from "./IbybSearch";
import { SpecialSearch } from "./SpecialSearch";

interface SearchProps {
    container: HTMLElement;
    couldNotResolveLocation: boolean;
    type: string;
}

export const Search: React.FC<SearchProps> = props => {
    const { site } = useContext(SearchContext);

    switch (site) {
        case "schoolsearch":
            return <SchoolSearch {...props} />;

        case "internationalschoolsearch":
            return <InternationalSchoolSearch {...props} />;

        case "ibyb":
            return <IbybSearch {...props} />;

        case "specialneedsguide":
            return <SpecialSearch {...props} />;

        default:
            throw new Error("Unhandled site!");
    }
};
